import { jwtDecode } from 'jwt-decode'

import { ACCESS_TOKEN_KEY } from '@/constants'
import { JWT, User } from '@/types'

export const getToken = () => localStorage.getItem(ACCESS_TOKEN_KEY)

const isExpired = (exp: number) => Date.now() / 1000 > exp

export const isValid = (token: string | null) => {
  if (!token) return false
  const { profile, exp } = jwtDecode<JWT>(token)
  if (profile !== 'teacher' || isExpired(exp)) return false
  return true
}

export const getProfile = () => {
  const token = getToken()
  if (!token || !isValid(token)) return null
  return jwtDecode<JWT & User>(token)
}
